exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tip[data-v-5d02f62a]{padding:0.0625rem 0.05208rem;font-size:0.07292rem;color:#637A95}\n", ""]);

// exports
